import React from 'react';
import { DomHelpers, Modal, Paging, StringHelpers, SystemText } from 'e4shared';
import { useDispatch, useSelector } from 'react-redux';
import { setShowSuccess } from 'actions/ui';
import { widgets } from 'data/widgets';

import './widgetPicker.css';
import { apiPost } from 'services';
import { hasModule } from 'helpers/profile';
import posthog from 'posthog-js';

export const WidgetPicker = ({ show, close, refresh, dashboardId, newY }) => {
    const pageSize = 8;
    const dispatch = useDispatch();
    const [pagedData, setPagedData] = React.useState([]);
    const [allWidgets, setAllWidgets] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [recordCount, setRecordCount] = React.useState(1);

    const user = useSelector(state => state.user.user);
    const hasCRM = hasModule(user, 'integrations') && user.crmIntegration;

    const resizeHandler = () => {
        setTimeout(() => {
            DomHelpers.arrangeTiles('widget-label-1');
            DomHelpers.arrangeTiles('widget-label-2');
        }, 250);
    };

    React.useEffect(() => {
        allWidgets.forEach(w => (w.name = SystemText(`Dashboard/Widgets/${StringHelpers.capitalise(w.widget)}/Title`)));
    }, [allWidgets, document.TRANSLATIONS]);

    React.useEffect(() => {
        resizeHandler();
    }, [show]);

    React.useEffect(() => {
        if (user) {
            const temp = [...widgets].filter(x => !x.show || x.show(user.companySettings));
            setAllWidgets(temp);
        }
    }, [user]);

    React.useEffect(() => {
        let temp = allWidgets.sort((a, b) => (a.name > b.name ? 1 : -1));
        const start = (page - 1) * pageSize + 1;
        setRecordCount(allWidgets.length);
        const end = start + pageSize > temp.length ? temp.length : start + pageSize - 1;
        temp = temp
            .filter(t => {
                return hasCRM || !t.crmOnly;
            })
            .reduce((result, d, i) => {
                if (i + 1 >= start && i + 1 <= end) result.push(d);
                return result;
            }, []);
        setPagedData(temp);
        resizeHandler();
    }, [page, allWidgets]);

    const addWidget = widget => {
        const h = widget.defaultH || 2;
        const w = widget.defaultW || 2;
        const newWidget = {
            dashboard_Id: dashboardId,
            name: widget.name,
            widget: widget.widget,
            w,
            h,
            x: 0,
            y: newY,
            data: JSON.stringify({ name: widget.name }),
        };

        apiPost('widget', newWidget, user.guid, () => {
            dispatch(setShowSuccess(SystemText('Dashboard/WidgetPicker/Success')));
            posthog.capture('widget-saved', { widget: newWidget.widget });
            refresh();
            close();
        });
    };

    const footer = (
        <div className="flex flex-center">
            <div className="flex-grow text-left">
                <Paging goToPage={setPage} pageSize={pageSize} recordCount={recordCount} page={page} />
            </div>
            <div>
                <button className="btn" onClick={close} data-testid="button-widget-picker-close">
                    {SystemText('Dashboard/WidgetPicker/Buttons/Close')}
                </button>
            </div>
        </div>
    );

    return (
        <Modal title={SystemText('Dashboard/WidgetPicker/Title')} show={show} close={close} footer={footer}>
            <div className="row">
                {pagedData.map((w, i) => {
                    return (
                        <div key={i} className="col-xs-6 col-md-3 widget-pick mb10">
                            <button
                                onClick={() => addWidget(w)}
                                className="btn widget-image mb10 btn-anycase"
                                data-testid={`button-widget-picker-${w.widget.toLowerCase()}`}
                            >
                                <img
                                    alt=""
                                    loading="lazy"
                                    src={`/dist/img/widgets/${w.widget}.jpg`}
                                    style={{ height: '110px', width: '110px' }}
                                />
                                <label className={`widget-label-${i < 4 ? '1' : '2'}`}>{w.name}</label>
                            </button>
                        </div>
                    );
                })}
            </div>
        </Modal>
    );
};

export default WidgetPicker;
